export default __webpack_public_path__ + "static/media/MonthlyReportActive.1398759e.svg";